import { render, staticRenderFns } from "./infoEditDetail.vue?vue&type=template&id=706efa1d&scoped=true"
import script from "./infoEditDetail.vue?vue&type=script&lang=ts"
export * from "./infoEditDetail.vue?vue&type=script&lang=ts"
import style0 from "./infoEditDetail.vue?vue&type=style&index=0&id=706efa1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706efa1d",
  null
  
)

export default component.exports